module.exports = __webpack_public_path__ + "static/media/DEval.d5e1347c.png";